<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 14 10"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.429 1.44998C13.429 1.93498 13.019 2.32798 12.513 2.32798H1.77299C1.26699 2.32798 0.856995 1.93498 0.856995 1.44998C0.856995 0.964984 1.26699 0.570984 1.77299 0.570984H12.513C13.019 0.570984 13.429 0.963984 13.429 1.44998ZM11.908 5.14298C11.908 5.62798 11.498 6.02098 10.992 6.02098H3.29299C2.78799 6.02098 2.37799 5.62798 2.37799 5.14298C2.37799 4.65798 2.78799 4.26498 3.29299 4.26498H10.993C11.498 4.26398 11.908 4.65698 11.908 5.14298ZM9.62699 8.83598C9.62699 9.32098 9.217 9.71398 8.711 9.71398H5.57499C5.06899 9.71398 4.65899 9.32098 4.65899 8.83598C4.65899 8.35098 5.06899 7.95698 5.57499 7.95698H8.70999C9.21599 7.95698 9.62699 8.34998 9.62699 8.83598Z"
      fill="currentColor"
    />
  </svg>
</template>
